export const ACTIVE_PROFILE_KEY = 'activeProfile';
export const ACTIVE_BUSINESS_PROFILE_ID_KEY = 'activeBusinessProfileId';

export function clearPersistedProfileState(storage: Storage): void {
  storage.removeItem(ACTIVE_PROFILE_KEY);
  storage.removeItem(ACTIVE_BUSINESS_PROFILE_ID_KEY);
}

export function getPersistedActiveBusinessProfileId(storage: Storage = localStorage): string | null {
  return storage.getItem(ACTIVE_BUSINESS_PROFILE_ID_KEY);
}
